import { getters } from './getters';
import { mutations } from './mutations';
import { actions } from './actions';

const state = {
  testDriveBookingsCalendar: [],
  testDriveBookingsTimeSlots: undefined,
  userTestDriveBookings: undefined,
  userTestDriveRequests: undefined,
};

export default {
  state,
  getters,
  mutations,
  actions,
};
